// extracted by mini-css-extract-plugin
export default {"GandiVector":"GandiVector-GandiVector__V0d3S","GandiVectorLeft":"GandiVector-GandiVectorLeft__KDcvF","GandiVectorRight":"GandiVector-GandiVectorRight__MEMoM"};